module.exports = __webpack_public_path__ + "assets/21e48663bc15fa3269e9a74fec44fedc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 374
// module chunks = 1